
import sidebarItem from './SidebarItem.vue'
export default  {
  name: 'navCollapseList',
  components: { sidebarItem },
  props: {
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    fontColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.87)'
    }
  },
  data() {
    return {
      collapseActive: [],
    }
  },
  computed: {
    collapseList() {
      let list = [
        {path: this.localePath('/'), title: this.$t('nav.home'), fullPath: '/', key: 'home', disabled: true},
        {path: '/AI', title: 'AI', fullPath: '/AI', id:11, linkTo: 'https://www.vastcloud.ai/'},
        {path: this.localePath('/klyr'), title: this.$t('nav.KLYR'), fullPath: '/', key: 'klyr', disabled: true, link: 'https://www.klyr.com.cn/'},
        {
          path: this.localePath('/technology'),
          title: this.$t('nav.Coretechnology'),
          fullPath: '/technology',
          key: 'technology',
          disabled: false,
          childrenList: [
            {
              path: this.localePath('/technology/procyon'), title: this.$t('nav.blockchain'), fullPath: '/technology', key: 'blockchain'
            },
            {
              path: this.localePath('/technology/arcturus'), title: this.$t('nav.Smartcontract'), fullPath: '/technology', key: 'arcturus'
            },
            {
              path: this.localePath('/technology/sirius'), title: this.$t('nav.Privacycomputing'), fullPath: '/technology', key: 'Privacycomputing'
            },
            {
              path: this.localePath('/technology/rigel'), title: this.$t('nav.Artificialintelligence'), fullPath: '/technology', key: 'Artificialintelligence'
            },
            {
              path: this.localePath('/technology/canopus'), title: this.$t('nav.Bigdata'), fullPath: '/technology', key: 'Bigdata'
            },
            {
              path: this.localePath('/technology/cloud'), title: this.$t('nav.Cloudcomputing'), fullPath: '/technology', key: 'Cloudcomputing'
            },
            // {
            //   path: this.localePath('/cbdc/galaxy'),
            //   title: this.$t('nav.Subroute["Overall architecture of CBDC"]'),
            //   fullPath: '/cbdc/galaxy',
            //   key: 'cbdcGalaxy',
            //   childrenList: [
            //     {
            //       path: this.localePath('/cbdc/galaxy/centralBank'),
            //       title: this.$t('nav.Subroute["Central Bank Governance"]'),
            //       fullPath: '/cbdc/galaxy/centralBank',
            //       key: 'cbdcGlaxyCentralBank'
            //     },
            //     {
            //       path: this.localePath('/cbdc/galaxy/technicalInfrastructure'),
            //       title: this.$t('nav.Subroute["Technological Infrastructure"]'),
            //       fullPath: '/cbdc/galaxy/technicalInfrastructure',
            //       key: 'cbdcGalaxyTechnicalInfrastructure'
            //     },
            //     {
            //       path: this.localePath('/cbdc/galaxy/wallet'),
            //       title: this.$t('nav.Subroute["Wallets and Accounts"]'),
            //       fullPath: '/cbdc/galaxy/wallet',
            //       key: 'cbdcGalaxyWallet'
            //     },
            //     {
            //       path: this.localePath('/cbdc/galaxy/tradingSettlement'),
            //       title: this.$t('nav.Subroute["Transactions and Settlements"]'),
            //       fullPath: '/cbdc/galaxy/tradingSettlement',
            //       key: 'cbdcGalaxyTradingSettlement'
            //     },
            //     {
            //       path: this.localePath('/cbdc/galaxy/kyc'),
            //       title: this.$t('nav.Subroute["Identity Verification and Know Your Customer"]'),
            //       fullPath: '/cbdc/galaxy/kyc',
            //       key: 'cbdcGalaxyKyc'
            //     },
            //     {
            //       path: this.localePath('/cbdc/galaxy/protect'),
            //       title: this.$t('nav.Subroute["Security and Preventive Measures"]'),
            //       fullPath: '/cbdc/galaxy/protect',
            //       key: 'cbdcGalaxyProtect'
            //     },
            //     {
            //       path: this.localePath('/cbdc/galaxy/supervise'),
            //       title: this.$t('nav.Subroute["Compliance and Regulation"]'),
            //       fullPath: '/cbdc/galaxy/supervise',
            //       key: 'cbdcGalaxySupervise'
            //     }]
            // },
          ]
        },
        {
          path: this.localePath('/applicationIntroduction'),
          title: this.$t('nav.Applicationintroduction'),
          fullPath: '/applicationIntroduction',
          key: 'applicationIntroduction',
          disabled: false,
          childrenList: [
            {
              path: this.localePath('/applicationIntroduction/c-end'),
              title: this.$t('nav.Cend'),
              fullPath: '/applicationIntroduction/c-end',
              key: 'Cend'
            },
            {
              path: this.localePath('/applicationIntroduction/b-end'),
              title: this.$t('nav.Bend'),
              fullPath: '/applicationIntroduction/b-end',
              key: 'Bend'
            },
            {
              path: this.localePath('/applicationIntroduction/g-end'),
              title: this.$t('nav.Gend'),
              fullPath: '/applicationIntroduction/g-end',
              key: 'Gend'
            },
            // {
            //   path: this.localePath('/coreTech/rigel'),
            //   title: this.$t('nav.Subroute["Artificial Intelligence"]'),
            //   fullPath: '/coreTech/rigel',
            //   key: 'coreTechRigel'
            // },
            // {
            //   path: this.localePath('/coreTech/canopus'),
            //   title: this.$t('nav.Subroute["Big Data"]'),
            //   fullPath: '/coreTech/canopus',
            //   key: 'coreTechCanopus'
            // },
            // {
            //   path: this.localePath('/coreTech/vega'),
            //   title: this.$t('nav.Subroute["Cloud Computing"]'),
            //   fullPath: '/coreTech/vega',
            //   key: 'coreTechVega'
            // },
          ]
        },
        {
          path: this.localePath('/case'),
          title: this.$t('nav.Servicecase'),
          fullPath: '/case',
          key: 'case',
          disabled: false,
          childrenList: [
            {
              path: this.localePath('/case/cnpc'),
              title: this.$t('nav.refueling'),
              fullPath: '/case/cnpc',
              key: 'refueling'
            },
            {
              path: this.localePath('/case/klsz'),
              title: this.$t('nav.Kunlunplatform'),
              fullPath: '/case/klsz',
              key: 'klsz'
            },
            {
              path: this.localePath('/case/ningbo'),
              title: this.$t('nav.Ningboplatform'),
              fullPath: '/case/ningbo',
              key: 'Ningboplatform'
            },
            // {
            //   path: this.localePath('/applicationIntroduction/settlement'),
            //   title: this.$t('nav.Subroute["Cross-border Settlement"]'),
            //   fullPath: '/applicationIntroduction/settlement',
            //   key: 'applicationIntroductionSettlement'
            // },
          ]
        },
        {
          path: this.localePath('/esg'),
          title: this.$t('nav.ESG'),
          fullPath: '/esg',
          key: 'esg',
          disabled: true
        },
        {
          path: this.localePath('/news'),
          title: this.$t('nav.Newscenter'),
          fullPath: '/news',
          key: 'news',
          disabled: true,
        },
        {
          path: this.localePath('/aboutUs'),
          title: this.$t('nav.Aboutus'),
          fullPath: '/aboutUs',
          key: 'aboutUs',
          disabled: true,
        },
        // {
        //   path: this.localePath('/joinUs'),
        //   title: this.$t('nav.Joinus'),
        //   fullPath: '/joinUs',
        //   key: 'Joinus',
        //   disabled: true,
        // },
        {
          path: this.localePath('/#cooperativePartner'),
          title: this.$t('nav.Businesspartner'),
          fullPath: '/#cooperativePartner',
          key: 'Businesspartner',
          disabled: true,
        },
        // {path: this.localePath('/esg'), title: this.$t('nav.ESG'), fullPath: '/esg', key: 'esg', disabled: true},
      ]
      if (this.$i18n.locale == 'en') {
        return list;
      } else {  
        return list.filter(item => {
          return item.path != '/AI';
        });
      }
    }
  },
  methods: {
    toLinkPath(item) {
      if (item?.linkTo) {
        window.location.href = item.linkTo;
      }
      if (item?.link) {
        window.open(item.link);
      }
      if(!item.childrenList) {
        this.$emit('close')
        return this.$router.push({
          path: item.path
        })

      }
    }
  }
}
